/** Logotipo MM Money em vetor (recriado a partir da referência aprovada — ver public/brand/LEIA-ME.txt e docs/brand/GUIA-DE-USO.md). */

/** Menu lateral (sempre azul-marinho): versão para fundo escuro; recolhido usa o ícone com fenda larga. */
export function BrandLogo({ collapsed = false }: { collapsed?: boolean }) {
  return collapsed
    ? <img src="/brand/mm-money-mark-pequeno.svg" alt="MM Money" />
    : <img src="/brand/mm-money-logo.svg" alt="MM Money — Inteligência para suas finanças" />;
}

/** Identificação institucional do ecossistema (MM Trading / UNSHAKEN), conforme o material original. */
export function EcosystemMark() {
  return <img src="/brand/ecossistema-mm-trading-unshaken.png" alt="Uma solução do ecossistema MM Trading e UNSHAKEN" />;
}

/** Telas de acesso: a variante certa para o tema (texto azul-marinho no claro, branco no escuro). */
export function Brand() {
  return (
    <div className="auth-brand">
      <img className="logo-on-light" src="/brand/mm-money-logo-claro.svg" alt="MM Money — Inteligência para suas finanças" />
      <img className="logo-on-dark" src="/brand/mm-money-logo.svg" alt="MM Money — Inteligência para suas finanças" />
    </div>
  );
}
